"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EventContainerContext_1 = require("./EventContainerContext");
const SuperEventEmitter_1 = require("./SuperEventEmitter");
/**
 * Event manager.
 */
class EventContainer extends SuperEventEmitter_1.SuperEventEmitter {
    constructor() {
        super(...arguments);
        /**
         * Event container contexts.
         * Used to separate listeners registered and easily remove them.
         */
        this.contexts = [];
    }
    /**
     * Creates new event container context.
     *
     * @return {EventContainerContext}
     */
    createContext() {
        const context = new EventContainerContext_1.default(this.destroyContext.bind(this), this.emitter.bind(this));
        this.contexts.push(context);
        return context;
    }
    /**
     * Destroys an event container context.
     *
     * @param {EventContainerContext} context
     *   The context to destroy.
     *
     * @return {boolean}
     *   Whether the context was found in this container and destroyed.
     */
    destroyContext(context) {
        const index = this.contexts.indexOf(context);
        if (index === -1) {
            return false;
        }
        context.removeAllListeners();
        this.contexts.splice(index, 1);
        return true;
    }
    /**
     * @inheritDoc
     */
    emit(event, ...args) {
        return this.emitter(event, ...args);
    }
    /**
     * @inheritDoc
     */
    listenerCount(type) {
        const contextCount = this.contexts.reduce((prev, context) => prev + context.listenerCount(type), 0);
        return super.listenerCount(type) + contextCount;
    }
    /**
     * Emits event to self and contexts.
     *
     * @param {string | symbol} event
     * @param args
     * @return {boolean}
     */
    emitter(event, ...args) {
        if (event === "error") {
            // Prevent multiple emission of same error object.
            if (args[0].__propagated__) {
                return true;
            }
            else {
                args[0].__propagated__ = true;
            }
        }
        let emitted = false;
        try {
            this.contexts.forEach((context) => {
                context.constructor.prototype.__proto__.emit.apply(context, [event, ...args]);
            });
            emitted = this.constructor.prototype.__proto__.emit.apply(this, [event, ...args]);
        }
        catch (error) {
            // Error events get thrown by the event emitter when there are no listeners.
            // This is a good practice, but since the container might have listeners
            // we have to check here as well before throwing as the container might
            // handle these errors while the context does not.
            if (args[0] !== error || this.listenerCount("error") === 0) {
                throw error;
            }
        }
        return emitted;
    }
}
exports.default = EventContainer;
